import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "footer-pane"
}

import { ref, computed, inject } from "vue";

import Menubar from 'primevue/menubar';

// TODO MenuBar has a pass-through (pt) prop where can can
// pass in context and set/fix the `active` tab to logging permanently
// while the logging drawer is open. Right now the pane remains open when
// the button goes back to looking "unpress".


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterDrawer',
  setup(__props) {


const isHelpOpen = ref(false);


// TODO should probably add handlers for Help|Terms|Contact
// Can also rename this file and make mor generic than Logging since it contains
// all "footer" links/actions
const footerMenuItems = ref([
    // {
    //     label: 'Help',
    //     icon: 'pi pi-question',
    //     command: () => {
    //         isAboutOpen.value = !isAboutOpen.value;
    //     }
    // },
    // {
    //     label: 'About',
    //     icon: 'pi pi-question',
    //     command: () => {
    //         contentSlug.value = 'about';
    //         isAboutOpen.value = !isAboutOpen.value;
    //     }
    // },
    {
        label: 'Shortcuts & help',
        icon: 'pi pi-compass',
        command: () => {
            isHelpOpen.value = !isHelpOpen.value;
        }
    },
    // {
    //     label: 'Terms',
    //     icon: 'pi pi-book'
    // },
    // {
    //     label: 'Contact',
    //     icon: 'pi pi-envelope'
    // }
]);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Menubar), {
      model: footerMenuItems.value,
      breakpoint: "800",
      class: "footer-menu-bar"
    }, null, 8, ["model"]),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (isHelpOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, "Keyboard Shortcuts"),
                _createElementVNode("pre", null, "Select cell above                           - ArrowUp | j | J\nSelect cell below                           - ArrowDown | k | K\nEdit selected cell                          - Enter\nStop editing selected cell                  - Esc\nInsert cell above selected cell             - a | A\nInsert cell below selected cell             - b | B\nDelete selected cell                        - d | D * twice *\nExecute selected cell and step to next cell - Shift-Enter\nExecute selected cell                       - Ctrl-Enter\n        ")
              ], -1),
              _createElementVNode("div", null, [
                _createElementVNode("h3", null, "Magic commands"),
                _createElementVNode("pre", null, "%set_context {context_slug} {language} {context_confg (json object)}\n\n%run_action {action_name} {payload (json object)}\n        ")
              ], -1)
            ])))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})